import { atom } from "jotai";

export const isInLanAtom = atom<boolean>(false);
